import LenderPageTemplate from '@/components/shared/LenderPageTemplate'

const SantanderPage = () => {
  return (
    <LenderPageTemplate
      lenderName="Santander"
      slug="/lenders/mis-sold-santander-car-finance"
      seoImage=""
      seoImageAlt=""
      aiOverview=""
    />
  )
}

export default SantanderPage
